export default "__VITE_ASSET__BFq6dpNQ__"